module.exports = __webpack_public_path__ + "img/journey-icon.d6da02a2.svg";